import { TableCellComponentProps } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import { SelectionCheckbox } from '../molecules/SelectionCheckbox';
import {
  getTableCellClasses,
  getTableCellProps,
  handleCellClick,
  isFlexColumn,
} from '../../utils/cellStyles';

export const CheckboxCell = ({
  value,
  column,
  state = 'default',
  onChange,
  className,
  onCellFocus,
  stickyLeft = 0,
  isLastLocked = false,
  isRowEditing,
  hasColumnMaxWidthAuto = false,
}: TableCellComponentProps) => {
  const baseClasses = getTableCellClasses(
    state,
    className,
    column.locked,
    isLastLocked,
    undefined,
    isRowEditing,
    false,
    column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto),
  );
  const cellProps = getTableCellProps(column, stickyLeft, undefined, false, hasColumnMaxWidthAuto);

  const hasFixedWidth = column.width !== undefined;
  return (
    <td className={baseClasses} {...cellProps} onClick={(e) => handleCellClick(e, onCellFocus)}>
      <div
        className={cn(
          'ui-flex ui-h-full ui-items-center ui-justify-center',
          hasFixedWidth && 'ui-min-w-0 ui-overflow-hidden',
        )}
      >
        <SelectionCheckbox
          checked={Boolean(value)}
          onChange={onChange || (() => {})}
          disabled={state === 'disabled'}
        />
      </div>
    </td>
  );
};
